<template>
    <date-picker
        v-model="dateValue"
        format="YYYY-MM-DD"
        type="date"
        :placeholder="placeholder"
        class="custom-date-picker"
        />
</template>
<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'customDatePicker',
  components: {
    DatePicker
  },
  data () {
    return {
      dateValue: null
    }
  },
  props: {
    value: null,
    placeholder: {
      type: String,
      default: 'Select date'
    },
    onDateChange: Function
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.dateValue = newVal
        }
      }
    },
    dateValue: {
      immediate: true,
      handler (newVal) {
        if (this.onDateChange) {
          this.onDateChange(newVal)
        }
      }
    }
  }
}
</script>
<style >
.custom-date-picker{
    width: fit-content;
}
.mx-input-wrapper input.mx-input {
    border-radius: 25px !important;
    padding: 18px 12px;
}
</style>
